import { ClientUpdateRequestType } from "./ClientUpdateRequestType";
import { Collection } from "../Collection";

export abstract class ClientUpdateHandler {
    abstract get type(): ClientUpdateRequestType;
    abstract handle(addlInputs: Collection<any>): void;
}
